import _objectWithoutPropertiesLoose from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js";
import _defineProperty from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var _excluded = ["pages"];
import * as React from 'react';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { styled, alpha, ThemeProvider } from '@mui/material/styles';
import List from '@mui/material/List';
import Drawer from '@mui/material/Drawer';
import Typography from '@mui/material/Typography';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Fade from '@mui/material/Fade';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import { unstable_useEnhancedEffect as useEnhancedEffect } from '@mui/utils';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import DoneRounded from '@mui/icons-material/DoneRounded';
import LogoWithCopyMenu from 'docs/src/components/action/LogoWithCopyMenu';
import AppNavDrawerItem from 'docs/src/modules/components/AppNavDrawerItem';
import { pageToTitleI18n } from 'docs/src/modules/utils/helpers';
import PageContext from 'docs/src/modules/components/PageContext';
import { useTranslate } from '@mui/docs/i18n';
import MuiProductSelector from 'docs/src/modules/components/MuiProductSelector';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// TODO: Collapse should expose an API to customize the duration based on the height.
function transitionTheme(theme) {
  return _extends({}, theme, {
    transitions: _extends({}, theme.transitions, {
      getAutoHeightDuration: function getAutoHeightDuration(height) {
        if (!height) {
          return 0;
        }
        var constant = height / 80;

        // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
        return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
      }
    })
  });
}
var savedScrollTop = {};
var customButtonStyles = function customButtonStyles(theme) {
  return {
    pl: 1,
    pr: '6px',
    height: 26,
    fontSize: theme.typography.pxToRem(13),
    fontWeight: theme.typography.fontWeightMedium,
    letterSpacing: '0.01rem'
  };
};
function ProductDrawerButton(props) {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  var anchorRef = React.useRef(null);
  var handleToggle = function handleToggle() {
    setOpen(function (prevOpen) {
      return !prevOpen;
    });
  };
  var handleClose = function handleClose(event) {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };
  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  }
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsx(Button, {
      size: "small",
      id: "mui-product-selector",
      ref: anchorRef,
      "aria-haspopup": "true",
      "aria-controls": open ? 'drawer-open-button' : undefined,
      "aria-expanded": open ? 'true' : undefined,
      onClick: handleToggle,
      endIcon: /*#__PURE__*/_jsx(ArrowDropDownRoundedIcon, {
        fontSize: "small",
        sx: {
          ml: -0.5
        }
      }),
      sx: customButtonStyles,
      children: props.productName
    }), /*#__PURE__*/_jsx(Popper, {
      open: open,
      anchorEl: anchorRef.current,
      role: undefined,
      placement: "bottom-start",
      disablePortal: true,
      transition: true,
      style: {
        zIndex: 1200
      },
      children: function children(_ref) {
        var TransitionProps = _ref.TransitionProps;
        return /*#__PURE__*/_jsx(Fade, _extends({}, TransitionProps, {
          timeout: 250,
          children: /*#__PURE__*/_jsx(Paper, {
            variant: "outlined",
            sx: function sx(theme) {
              return _extends({
                mt: 1,
                minWidth: {
                  xs: '100%',
                  sm: 600
                },
                overflow: 'clip',
                boxShadow: "0 4px 16px ".concat(alpha(theme.palette.common.black, 0.15))
              }, theme.applyDarkStyles({
                bgcolor: 'primaryDark.900'
              }));
            },
            children: /*#__PURE__*/_jsx(ClickAwayListener, {
              onClickAway: handleClose,
              children: /*#__PURE__*/_jsx(MuiProductSelector, {
                autoFocusItem: open,
                id: "mui-product-menu",
                "aria-labelledby": "mui-product-selector",
                onKeyDown: handleListKeyDown
              })
            })
          })
        }));
      }
    })]
  });
}
false ? void 0 : void 0;
function ProductIdentifier(props) {
  var name = props.name,
    metadata = props.metadata,
    versionSelector = props.versionSelector;
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      flexGrow: 1
    },
    children: [/*#__PURE__*/_jsx(Typography, {
      sx: function sx(theme) {
        return {
          ml: '6px',
          fontSize: theme.typography.pxToRem(10),
          fontWeight: theme.typography.fontWeightBold,
          textTransform: 'uppercase',
          letterSpacing: '.1rem',
          color: (theme.vars || theme).palette.text.tertiary
        };
      },
      children: metadata
    }), /*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex'
      },
      children: [/*#__PURE__*/_jsx(ProductDrawerButton, {
        productName: name
      }), versionSelector]
    })]
  });
}
false ? void 0 : void 0;

// To match scrollMarginBottom
var browserUrlPreviewMarge = 120;
function PersistScroll(props) {
  var slot = props.slot,
    children = props.children,
    enabled = props.enabled;
  var rootRef = React.useRef(null);
  useEnhancedEffect(function () {
    var scrollContainer = rootRef.current ? rootRef.current.parentElement : null;
    var activeDrawerLink = scrollContainer == null ? void 0 : scrollContainer.querySelector('.app-drawer-active');
    if (!enabled || !scrollContainer || !activeDrawerLink || !activeDrawerLink.scrollIntoView) {
      return undefined;
    }
    scrollContainer.scrollTop = savedScrollTop[slot];
    var activeBox = activeDrawerLink.getBoundingClientRect();
    if (activeBox.top < 0 || activeBox.bottom + browserUrlPreviewMarge > window.innerHeight) {
      // Scroll the least possible from the initial render, for example server-side, scrollTop = 0.
      activeDrawerLink.scrollIntoView({
        block: 'nearest'
      });
    }
    return function () {
      // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- useEnhancedEffect uses useEffect under the hood
      savedScrollTop[slot] = scrollContainer.scrollTop;
    };
  }, [enabled, slot]);
  return /*#__PURE__*/_jsx("div", {
    ref: rootRef,
    children: children
  });
}
false ? void 0 : void 0;
var ToolbarDiv = styled('div')(function (_ref2) {
  var theme = _ref2.theme;
  return {
    padding: theme.spacing(1.5),
    paddingRight: 0,
    flexShrink: 0,
    height: 'var(--MuiDocs-header-height)',
    boxSizing: 'border-box',
    // TODO have CssBaseline in the Next.js layout
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid',
    borderColor: (theme.vars || theme).palette.divider
  };
});
var StyledDrawer = styled(Drawer)(function (_ref3) {
  var theme = _ref3.theme;
  return _defineProperty(_defineProperty({}, theme.breakpoints.up('xs'), {
    display: 'none'
  }), theme.breakpoints.up('lg'), {
    display: 'block'
  });
});
var AppNavPaperComponent = styled('div')(function () {
  return {
    width: 'var(--MuiDocs-navDrawer-width)',
    boxShadow: 'none',
    border: '0 !important',
    // TODO add a Paper slot
    overflowY: 'unset !important',
    // TODO add a Paper slot
    boxSizing: 'border-box' // TODO have CssBaseline in the Next.js layout
  };
});
function renderNavItems(options) {
  var pages = options.pages,
    params = _objectWithoutPropertiesLoose(options, _excluded);
  return /*#__PURE__*/_jsx(List, {
    children: pages.reduce(function (items, page) {
      return reduceChildRoutes(_extends({
        items: items,
        page: page
      }, params));
    }, [])
  });
}
function reduceChildRoutes(context) {
  var onClose = context.onClose,
    activePageParents = context.activePageParents,
    items = context.items,
    depth = context.depth,
    t = context.t;
  var page = context.page;
  if (page.inSideNav === false) {
    return items;
  }
  var title = pageToTitleI18n(page, t);
  if (page.children && page.children.length >= 1) {
    var topLevel = activePageParents.some(function (_ref5) {
      var pathname = _ref5.pathname;
      return pathname === page.pathname;
    });
    var firstChild = page.children[0];
    if (firstChild.subheader && firstChild.children) {
      firstChild = firstChild.children[0];
    }
    var subheader = Boolean(page.subheader);
    var _firstChild$pathname$ = firstChild.pathname.split('#'),
      _firstChild$pathname$2 = _slicedToArray(_firstChild$pathname$, 2),
      path = _firstChild$pathname$2[0],
      hash = _firstChild$pathname$2[1];
    items.push(/*#__PURE__*/_jsx(AppNavDrawerItem, {
      linkProps: page.linkProps,
      depth: depth,
      title: title,
      href: _extends({
        pathname: path
      }, firstChild.query && {
        query: firstChild.query
      }, hash && {
        hash: hash
      }),
      legacy: page.legacy,
      newFeature: page.newFeature,
      planned: page.planned,
      unstable: page.unstable,
      beta: page.beta,
      deprecated: page.deprecated,
      plan: page.plan,
      icon: page.icon,
      subheader: subheader,
      topLevel: topLevel && !page.subheader,
      initiallyExpanded: topLevel || subheader,
      expandable: !subheader,
      children: renderNavItems({
        onClose: onClose,
        pages: page.children,
        activePageParents: activePageParents,
        depth: subheader ? depth : depth + 1,
        t: t
      })
    }, title));
  } else {
    var _page$pathname$split = page.pathname.split('#'),
      _page$pathname$split2 = _slicedToArray(_page$pathname$split, 2),
      _path = _page$pathname$split2[0],
      _hash = _page$pathname$split2[1];
    items.push(/*#__PURE__*/_jsx(AppNavDrawerItem, {
      linkProps: page.linkProps,
      depth: depth,
      title: title,
      href: _extends({
        pathname: _path
      }, page.query && {
        query: page.query
      }, _hash && {
        hash: _hash
      }),
      legacy: page.legacy,
      newFeature: page.newFeature,
      planned: page.planned,
      unstable: page.unstable,
      beta: page.beta,
      deprecated: page.deprecated,
      plan: page.plan,
      icon: page.icon,
      subheader: Boolean(page.subheader),
      onClick: onClose
    }, title));
  }
  return items;
}

// iOS is hosted on high-end devices. We can enable the backdrop transition without
// dropping frames. The performance will be good enough.
// So: <SwipeableDrawer disableBackdropTransition={false} />
var iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);
export default function AppNavDrawer(props) {
  var className = props.className,
    disablePermanent = props.disablePermanent,
    mobileOpen = props.mobileOpen,
    onClose = props.onClose,
    onOpen = props.onOpen;
  var _React$useContext = React.useContext(PageContext),
    activePageParents = _React$useContext.activePageParents,
    pages = _React$useContext.pages,
    productIdentifier = _React$useContext.productIdentifier;
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    anchorEl = _React$useState4[0],
    setAnchorEl = _React$useState4[1];
  var t = useTranslate();
  var mobile = useMediaQuery(function (theme) {
    return theme.breakpoints.down('lg');
  });
  var swipeableDrawer = disablePermanent || mobile;
  var drawer = React.useMemo(function () {
    var navItems = renderNavItems({
      onClose: onClose,
      pages: pages,
      activePageParents: activePageParents,
      depth: 0,
      t: t
    });
    var renderVersionSelector = function renderVersionSelector(versions) {
      if (!(versions != null && versions.length)) {
        return null;
      }
      var currentVersion = versions.find(function (version) {
        return version.current;
      }) || versions[0];
      return /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx(Button, {
          variant: "text",
          color: "secondary",
          size: "small",
          id: "mui-version-selector",
          onClick: function onClick(event) {
            setAnchorEl(event.currentTarget);
          },
          endIcon: versions.length > 1 ? /*#__PURE__*/_jsx(ArrowDropDownRoundedIcon, {
            fontSize: "small",
            sx: {
              ml: -0.5
            }
          }) : null,
          sx: customButtonStyles,
          children: currentVersion.text
        }), /*#__PURE__*/_jsx(Menu, {
          id: "mui-version-menu",
          anchorEl: anchorEl,
          open: Boolean(anchorEl),
          onClose: function onClose() {
            return setAnchorEl(null);
          },
          children: versions.map(function (item) {
            if (item.text === 'View all versions') {
              return [/*#__PURE__*/_jsx(Divider, {}, "divider"), /*#__PURE__*/_jsx(MenuItem, {
                component: "a",
                href: item.href,
                onClick: onClose,
                children: "View all versions"
              }, "all-versions")];
            }
            return /*#__PURE__*/_jsxs(MenuItem, _extends({}, item.current ? {
              selected: true,
              onClick: function onClick() {
                return setAnchorEl(null);
              }
            } : {
              component: 'a',
              href: item.href,
              onClick: onClose
            }, {
              children: [item.text, " ", item.current && /*#__PURE__*/_jsx(DoneRounded, {
                sx: {
                  fontSize: 16,
                  ml: 'auto'
                }
              })]
            }), item.text);
          })
        })]
      });
    };
    if (false) renderVersionSelector.displayName = "renderVersionSelector";
    return /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsxs(ToolbarDiv, {
        children: [/*#__PURE__*/_jsx(LogoWithCopyMenu, {
          logo: productIdentifier.logo,
          logoSvgString: productIdentifier.logoSvg,
          wordmarkSvgString: productIdentifier.wordmarkSvg
        }), /*#__PURE__*/_jsx(ProductIdentifier, {
          name: productIdentifier.name,
          metadata: productIdentifier.metadata,
          versionSelector: renderVersionSelector(productIdentifier.versions)
        })]
      }), /*#__PURE__*/_jsx(Box, {
        sx: _extends({
          pt: 0.5,
          pb: 5,
          overflowY: 'auto',
          flexGrow: 1
        }, swipeableDrawer ? {} : {
          borderRight: '1px solid',
          borderColor: 'divider'
        }),
        children: /*#__PURE__*/_jsx(PersistScroll, {
          slot: "side",
          enabled: true,
          children: navItems
        })
      })]
    });
  }, [onClose, pages, activePageParents, t, productIdentifier, anchorEl, swipeableDrawer]);
  if (false) {
    if (!productIdentifier) {
      throw new Error('docs-infra: missing productIdentifier in PageContext');
    }
    if (!productIdentifier.versions) {
      throw new Error('docs-infra: missing productIdentifier.versions in PageContext');
    }
  }
  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: transitionTheme,
    children: /*#__PURE__*/_jsx("nav", {
      className: className,
      "aria-label": t('mainNavigation'),
      children: swipeableDrawer ? /*#__PURE__*/_jsx(SwipeableDrawer, {
        disableBackdropTransition: !iOS,
        variant: "temporary",
        open: mobileOpen,
        onOpen: onOpen,
        onClose: onClose,
        ModalProps: {
          keepMounted: true
        },
        PaperProps: {
          component: AppNavPaperComponent
        },
        children: drawer
      }) : /*#__PURE__*/_jsx(StyledDrawer, {
        variant: "permanent",
        PaperProps: {
          component: AppNavPaperComponent
        },
        open: true,
        children: drawer
      })
    })
  });
}
false ? void 0 : void 0;